import LineCompassIcon from 'components/Luxkit/Icons/line/LineCompassIcon'
import TextLink from 'components/Luxkit/TextLink'
import React, { useCallback, useContext } from 'react'
import AdditionalWaysToExperienceMessagingTile from './AdditionalWaysToExperienceMessagingTile'
import ModalContext from 'contexts/ModalContext'
import PrivateRequestFormModal from 'components/OfferPage/TourV2/PrivateRequest/PrivateRequestFormModal'

interface Props {
  offer: App.Tours.TourV2Offer
}

function PrivateDepartureMessagingTile(props: Props) {
  const { offer } = props
  const showModal = useContext(ModalContext)

  const requestPrivateTour = useCallback(() => {
    showModal(<PrivateRequestFormModal offer={offer} />)
  }, [showModal, offer])

  return <AdditionalWaysToExperienceMessagingTile
    heading="Private Departure"
    description="Travel exclusively with family and friends at a time that works best for you."
    Icon={LineCompassIcon}
    action={<TextLink size="small" onClick={requestPrivateTour}>Submit a request</TextLink>}
  />
}

export default PrivateDepartureMessagingTile
